var _templateObject = _taggedTemplateLiteralLoose(['\n  right: 1rem;\n  position: absolute;\n  font-size: 1.5rem;\n  cursor: pointer;\n\n  @media (min-width: 600px) {\n    display: none;\n  }\n'], ['\n  right: 1rem;\n  position: absolute;\n  font-size: 1.5rem;\n  cursor: pointer;\n\n  @media (min-width: 600px) {\n    display: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0.5rem 0;\n  text-align: center;\n  background: ', ';\n  margin: 0;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  box-sizing: border-box;\n  height: 48px;\n  width: 100%;\n  line-height: 32px;\n  box-shadow: 0 1px 5px 0 rgba(32, 24, 73, 0.39);\n  z-index: 999;\n\n  @media (min-width: 600px) {\n    width: ', ';\n    border-radius: 6px 6px 0 0;\n  }\n'], ['\n  padding: 0.5rem 0;\n  text-align: center;\n  background: ', ';\n  margin: 0;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  box-sizing: border-box;\n  height: 48px;\n  width: 100%;\n  line-height: 32px;\n  box-shadow: 0 1px 5px 0 rgba(32, 24, 73, 0.39);\n  z-index: 999;\n\n  @media (min-width: 600px) {\n    width: ', ';\n    border-radius: 6px 6px 0 0;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

var Header = function Header(props) {
  return React.createElement(
    'h1',
    { className: props.className },
    props.children,
    props.open && React.createElement(
      StyledHeaderIcon,
      { onClick: props.onClick },
      '\xD7'
    )
  );
};

var StyledHeaderIcon = styled.span(_templateObject);

var StyledHeader = styled(Header)(_templateObject2, function (props) {
  return props.theme.color;
}, function (props) {
  return props.theme.width;
});

export default StyledHeader;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/header.js
// module id = 754
// module chunks = 1